import React from 'react';
import OutstandingReport from "../elements/OutstandingReport";
class AgencyOutstandingPayment extends React.Component {
    render() {
        return (
           <OutstandingReport userPermandMasters={this.props.userPermandMasters} user_Type="A" title="Agency Outstanding Payment Report"></OutstandingReport>
        );
    }
}
export default AgencyOutstandingPayment;